import { CALL_CENTER_ACTION_TYPES } from '../actions/ActionCallCenter';

const initialState = {
    loading: false,
    error: null,

    contacts: [],
    presets: [],
    calls: [],
    labels: [],

    activeCall: null,
    callConnection: null,
    totalCalls: 0,

    // Real-time data
    callEvents: {},
    audioData: {},
};

export const callCenterReducer = (state = initialState, action) => {
    switch (action.type) {
        case CALL_CENTER_ACTION_TYPES.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.CLEAR_ERROR:
            return {
                ...state,
                error: null,
            };

        // Contacts
        case CALL_CENTER_ACTION_TYPES.SET_CONTACTS:
            return {
                ...state,
                contacts: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.ADD_CONTACT:
            return {
                ...state,
                contacts: [...state.contacts, action.payload],
            };

        case CALL_CENTER_ACTION_TYPES.UPDATE_CONTACT:
            return {
                ...state,
                contacts: state.contacts.map((contact) =>
                    (contact.id || contact._id) === action.payload.contactId
                        ? { ...contact, ...action.payload.updates }
                        : contact
                ),
            };

        case CALL_CENTER_ACTION_TYPES.DELETE_CONTACT:
            return {
                ...state,
                contacts: state.contacts.filter((contact) => (contact.id || contact._id) !== action.payload),
            };

        // Presets
        case CALL_CENTER_ACTION_TYPES.SET_PRESETS:
            return {
                ...state,
                presets: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.ADD_PRESET:
            return {
                ...state,
                presets: [...state.presets, action.payload],
            };

        case CALL_CENTER_ACTION_TYPES.UPDATE_PRESET:
            return {
                ...state,
                presets: state.presets.map((preset) =>
                    (preset.id || preset._id) === action.payload.presetId
                        ? { ...preset, ...action.payload.updates }
                        : preset
                ),
            };

        case CALL_CENTER_ACTION_TYPES.DELETE_PRESET:
            return {
                ...state,
                presets: state.presets.filter((preset) => (preset.id || preset._id) !== action.payload),
            };

        // Labels
        case CALL_CENTER_ACTION_TYPES.SET_LABELS:
            return {
                ...state,
                labels: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.ADD_LABEL:
            return {
                ...state,
                labels: [...state.labels, action.payload],
            };

        case CALL_CENTER_ACTION_TYPES.UPDATE_LABEL:
            return {
                ...state,
                labels: state.labels.map((label) =>
                    (label.id || label._id) === action.payload.labelId ? { ...label, ...action.payload.updates } : label
                ),
            };

        case CALL_CENTER_ACTION_TYPES.DELETE_LABEL:
            return {
                ...state,
                labels: state.labels.filter((label) => (label.id || label._id) !== action.payload),
            };

        // Calls
        case CALL_CENTER_ACTION_TYPES.SET_CALLS:
            return {
                ...state,
                calls: action.payload,
            };
        case CALL_CENTER_ACTION_TYPES.SET_TOTAL_CALLS:
            return {
                ...state,
                totalCalls: action.payload,
            };
        case CALL_CENTER_ACTION_TYPES.ADD_CALL:
            return {
                ...state,
                calls: [action.payload, ...state.calls],
            };

        case CALL_CENTER_ACTION_TYPES.UPDATE_CALL:
            return {
                ...state,
                calls: state.calls.map((call) =>
                    (call.id || call._id) === action.payload.callId ? { ...call, ...action.payload.updates } : call
                ),
                activeCall:
                    state.activeCall && (state.activeCall.id || state.activeCall._id) === action.payload.callId
                        ? { ...state.activeCall, ...action.payload.updates }
                        : state.activeCall,
            };

        case CALL_CENTER_ACTION_TYPES.SET_ACTIVE_CALL:
            return {
                ...state,
                activeCall: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.CLEAR_ACTIVE_CALL:
            return {
                ...state,
                activeCall: null,
                callConnection: null,
            };

        // Real-time Updates
        case CALL_CENTER_ACTION_TYPES.CALL_STATUS_UPDATE:
            return {
                ...state,
                calls: state.calls.map((call) =>
                    (call.id || call._id) === action.payload.callId
                        ? { ...call, callStatus: action.payload.status }
                        : call
                ),
                activeCall:
                    state.activeCall && (state.activeCall.id || state.activeCall._id) === action.payload.callId
                        ? { ...state.activeCall, callStatus: action.payload.status }
                        : state.activeCall,
            };

        case CALL_CENTER_ACTION_TYPES.CALL_EVENT_UPDATE:
            return {
                ...state,
                callEvents: {
                    ...state.callEvents,
                    [action.payload.callId]: [...(state.callEvents[action.payload.callId] || []), action.payload.event],
                },
            };

        case CALL_CENTER_ACTION_TYPES.AUDIO_DATA_UPDATE:
            return {
                ...state,
                audioData: {
                    ...state.audioData,
                    [action.payload.callId]: action.payload,
                },
            };

        // Connection
        case CALL_CENTER_ACTION_TYPES.SET_CALL_CONNECTION:
            return {
                ...state,
                callConnection: action.payload,
            };

        case CALL_CENTER_ACTION_TYPES.CLEAR_CALL_CONNECTION:
            return {
                ...state,
                callConnection: null,
            };

        default:
            return state;
    }
};
